export default __webpack_public_path__ + "static/media/featured-homepage-mobile.f1bd45c7.png";